<div>
	<h1 class="h2 mb-4">{{'nav.devices_connectivity_report' | translate}}</h1>
	<div class="d-flex justify-content-end mt-1 ml-2">
		<button class="btn btn-primary pointer" (click)="exportToCsvFile()">{{'g.export_to_csv' | translate}}</button>
	</div>
	<sct-custom-table
        #sctCustomTable
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
        (backEndPaginationFunc)="getDevicesConnectivityData($event)"
	></sct-custom-table>
</div>